import { Component, Inject, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ExecutionQ, ExecutionStatus } from '../../../../model/execution';
import { ProtocolQ } from '../../../../model/protocol';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ArrayUtils } from '../../../../utils/arrayUtils';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { StringUtils } from '../../../../utils/stringUtils';
import { ExecutionQService } from '../../../../services/executionQ.service';
import { TestQualificationTypeShort } from '../../../../model/testQualificationType';
import { TestQType } from '../../../../model/testQType';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { ReasonDialogComponent } from '../../../shared/reason-dialog/reason-dialog.component';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { Router } from '@angular/router';

export interface DialogDataValidateExecution {
  execution: ExecutionQ;
  protocol: ProtocolQ;
  documentSigned: File;
  testQualificationType: TestQualificationTypeShort[];
}

@Component({
    selector: 'app-execution-edit-q-validate-execution',
    templateUrl: './execution-edit-q-validate-execution.component.html',
    styleUrls: ['./execution-edit-q-validate-execution.component.scss'],
    standalone: false,
})
export class ExecutionEditQValidateExecutionComponent implements OnInit {

  forceAccording: boolean;
  reasonForce = '';
  reason: string;
  errors: string[];
  warns: string[];
  private destroy$ = new Subject<void>();

  mainForm: FormGroup;

  constructor(fb: FormBuilder,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataValidateExecution,
    public dialogRef: MatDialogRef<ExecutionEditQValidateExecutionComponent>,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    public executionService: ExecutionQService,
    private spinnerService: SpinnerService,
    private router: Router) {
    this.mainForm = fb.group({
      forceAccording: [this.forceAccording],
      reasonForce: [this.reasonForce],
      reason: [this.reason]
    });
  }

  ngOnInit(): void {
    this.errors = [];
    this.warns = [];

    this.spinnerService.show();

    const force: boolean = this.data.execution.according != null ? this.data.execution.according.valueOf() : false;
    this.forceAccording = !force;
    this.reasonForce = StringUtils.isNotEmpty(this.data.execution.accordingReason) ? this.data.execution.accordingReason : null;
    this.reason = this.data.execution.reason;

    this.spinnerService.show();

    this.errors = [];
    this.warns = [];

    this.spinnerService.show();
    this.executionService.checkForAdvance(this.data.execution.id).pipe(takeUntil(this.destroy$)).subscribe((resAccording: string) => {
      if (resAccording != null) {
        if (resAccording === 'not_according') {
          this.errors.push(this.translate.instant('executionEditQ.result.validation.invalid'));
        } else if (resAccording === 'according_conditioned') {
          this.warns.push(this.translate.instant('executionEditQ.result.validation.according_conditioned'));
        }
      }

      this.spinnerService.hide();
    });
  }

  showReason(): boolean {
    return (+this.data.execution.currentVersion) > 1;
  }

  isEmpty(array: any[]): boolean {
    return ArrayUtils.isEmpty(array);
  }

  canAccept(): boolean {
    let res = false;

    if (this.errors == null) {
      res = true;
    } else if (this.forceAccording) {
      res = true;
    } else if (this.reasonForce != null && this.reasonForce !== '') {
      res = true;
    } else if (this.data.execution.idStatus === ExecutionStatus.EN_EJECUCION) {
      res = true;
    }

    return res;
  }

  onOkClick(): void {
    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        this.spinnerService.show();
        this.data.execution.reason = this.reason;
        this.executionService.validate(this.data.execution.id, result, this.forceAccording, this.reasonForce).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQ) => {
          this.spinnerService.hide();
          this.dialogRef.close(true)
          
        }, error => {
          this.dialogRef.close(false);
          this.spinnerService.hide();
          console.log(error);
        });
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  errorExecute(): string[] {
    let errors = [];
    for (let indexTest = 0; indexTest < this.data.execution.executionQTests?.length; indexTest++) {
      const elementTest = this.data.execution.executionQTests[indexTest];

      for (let indexDev = 0; indexDev < elementTest.deviations?.length; indexDev++) {
        const elementDev = elementTest.deviations[indexDev];

        const isCritical = elementDev.executionQTestDeviationData.some(e => e.idType === 2 && e.valuation === 1);
        if (isCritical) {
          const isNotResolvedData = elementDev.executionQTestDeviationData.some(e => e.idType === 5);
          if (isNotResolvedData) {
            const isNotResolved = elementDev.executionQTestDeviationData.some(e => e.idType === 5 && !e.resolved);
            if (isNotResolved) {
              errors.push(this.translate.instant('executionEditQ.deviation.error') as string);
            }
          } else {
            errors.push(this.translate.instant('executionEditQ.deviation.error') as string);
          }
        } else {
          const isNotContinue = elementDev.executionQTestDeviationData.some(e => e.idType === 2 && !e.qualificationContinue);

          if (isNotContinue) {
            errors.push(this.translate.instant('executionEditQ.deviation.error') as string);
          }
        }

      }
    }

    return errors;
  }

  isCompletedTest(idTestType: number): boolean {
    let res = [];
    const testResult = this.data.execution.executionQTests.find(e => e.idTestType === idTestType);

    if (testResult) {

      for (let indexGroup = 0; indexGroup < testResult.executionQTestItemGroup?.length; indexGroup++) {
        const group = testResult.executionQTestItemGroup[indexGroup];
        for (let index = 0; index < group.executionQTestItems?.length; index++) {
          const element = group.executionQTestItems[index];

          for (let indextiv = 0; indextiv < element.executionQTestItemVerification.length; indextiv++) {
            const elementtiv = element.executionQTestItemVerification[indextiv];

            for (let indextdm = 0; indextdm < elementtiv.executionQTestDataMultiple?.length; indextdm++) {
              const element = elementtiv.executionQTestDataMultiple[indextdm];
              if (!element.obtainedResult) {
                res.push(true);
              } else {
                res.push(false);
              }
            }
          }
        }
      }

      if (idTestType === 8) {
        if (testResult.executionQTestCriticalInstrumentation && testResult.executionQTestCriticalInstrumentation?.length > 0) {
          for (let indexCal = 0; indexCal < testResult.executionQTestCriticalInstrumentation?.length; indexCal++) {
            const cal = testResult.executionQTestCriticalInstrumentation[indexCal];
            if (!cal.equipment) {
              res.push(true);
            } else {
              res.push(false);
            }

            if (!cal.procediment) {
              res.push(true);
            } else {
              res.push(false);
            }
          }
        } else {
          res.push(true);
        }

      }
      return !res.find(e => e === true);
    } else {
      return false;
    }
  }

  private requestReason(callback: (reason: string) => void) {
      const dialogRef = this.dialog.open(ReasonDialogComponent, {
        minWidth: '40%',
        maxHeight: '95vh',
        data: {}
      });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
        if (result != null) {
          callback(result);
        }
      });
    }
  
    private requestSign(callback: (token: string) => void) {
      this.spinnerService.hide();
  
      const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
        minWidth: '20%',
        maxHeight: '95vh',
        data: {}
      });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
        if (result != null) {
          callback(result);
        }
      });
    }

}
